import { callApi } from "Apis";
import { OCCASIONURL } from "helpers/constant";

export async function occasionList(data) {
  try {
    const response = await callApi({ url: OCCASIONURL.LIST, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function occasionAdd(data) {
  try {
    const response = await callApi({ url: OCCASIONURL.ADD, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function getOccasionById(id) {
  try {
    const response = await callApi({ url: OCCASIONURL.GET(id), method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}
export async function updateOccasion(data) {
  try {
    const response = await callApi({ url: OCCASIONURL.UPDATE, body: data, method: "PUT" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function deleteOccasionById(id) {
  try {
    const response = await callApi({ url: OCCASIONURL.DELETE(id), method: "DELETE" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function occasionOption(data) {
  try {
    const response = await callApi({ url: OCCASIONURL.OPTION, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}
